// src/components/AiHelperNotice.js
//
// The one warning shown wherever this workflow shows AI output (decided
// 2026-10-23): Protocol Compare's summary, Screening Visit, and SourceX's
// protocol, eCRF, Map & Create and source-document pages. Same words
// everywhere; a line of context can follow. Its own classes, both modes.

import { AlertTriangle } from "lucide-react";

export const AI_HELPER_TEXT = "AI can make mistakes. Use this as a helper, not the final word.";

/** @param {{children?: any, className?: string, compact?: boolean}} props */
const AiHelperNotice = ({ children, className = "", compact = false }) => (
  <div
    role="note"
    className={`ai-helper-notice flex items-start gap-2 rounded-lg border border-amber-400/30 bg-amber-500/10 ${
      compact ? "px-2.5 py-1.5 text-[11px]" : "px-3 py-2 text-xs"
    } text-amber-100 ${className}`}
  >
    <AlertTriangle className={`${compact ? "w-3.5 h-3.5" : "w-4 h-4"} shrink-0 mt-0.5 text-amber-300`} />
    <span>
      <strong className="font-semibold">AI can make mistakes.</strong> Use this as a helper, not the final word.
      {children ? <> {children}</> : null}
    </span>
  </div>
);

export default AiHelperNotice;
